<table>
    <tr>
        <td>
            {{ 'LiveVoting.PresenceTotalVotes' | translate }}
        </td>
        <td class="text-right px-2">
            {{ agendaItem().presenceTotalVotes | slNumber }}
        </td>
        <td></td>
    </tr>
    <tr class="font-weight-bold">
        <td>
            {{ agendaItem().presenceMajorityVotesLabel }}
        </td>
        <td class="text-right px-2">
            {{ agendaItem().presenceMajorityVotes | slNumber }}
        </td>
        <td></td>
    </tr>
    <tr class="results">
        <td class="voting-yes">
            {{ 'Voting.Yes' | translate }}
        </td>
        <td class="text-right px-2">
            {{ agendaItem().resultYes | slNumber }}
        </td>
        <td class="text-right px-2">{{ agendaItem().resultYesPercent }}%</td>
    </tr>
    <tr>
        <td class="voting-no">
            {{ 'Voting.No' | translate }}
        </td>
        <td class="text-right px-2">
            {{ agendaItem().resultNo | slNumber }}
        </td>
        <td class="text-right px-2">{{ agendaItem().resultNoPercent }}%</td>
    </tr>
    <tr>
        <td class="voting-abstained">
            {{ 'Voting.Abstain' | translate }}
        </td>
        <td class="text-right px-2">
            {{ agendaItem().resultAbstention | slNumber }}
        </td>
        <td class="text-right px-2">{{ agendaItem().resultAbstentionPercent }}%</td>
    </tr>
</table>
